import React from 'react';

import Modal from '../Modal';
import { ContainedButton, OutlinedButton } from '../Buttons';
import styles from './GeneratedMoviesWarningModal.module.scss';

type TGeneratedMoviesWarningModal = {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
};

const GeneratedMoviesWarningModal: React.FC<TGeneratedMoviesWarningModal> = ({
  open,
  onConfirm,
  onClose,
  loading = false,
}) => {
  return (
    <Modal open={open} onClose={onClose} loading={loading}>
      <div className={styles.modalBody} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>
          Any changes you make will invalidate previously generated movies.
        </div>

        <div className={styles.actionBtns}>
          <OutlinedButton onClick={onConfirm} disabled={loading} kind="default">
            Continue
          </OutlinedButton>

          <ContainedButton kind="purple" disabled={loading} onClick={onClose}>
            Cancel
          </ContainedButton>
        </div>
      </div>
    </Modal>
  );
};

export default GeneratedMoviesWarningModal;
